import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import * as VseSession from '../../features/session';

export function LogoutPage() {
  const sessionState = VseSession.useVseSessionState();
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(VseSession.logout());
  }, [dispatch]);

  React.useEffect(() => {
    if (sessionState.loading === 'loggedOut') {
      dispatch(VseSession.reset());
    }
  }, [dispatch, sessionState.loading]);

  switch (sessionState.loading) {
    case 'idle': //  after reset
      return (<Redirect to='./' />);
    default:
      return (
        <Backdrop open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
      );
  }
}
